/**
 * Enemy types enum for different enemy units in the game
 * Based on the original game's enemy craft and tank types
 */

export enum EnemyType {
  // Air units
  E_DACOS = "E-Dacos",
  FESTA_WORM = "Festa Worm",
  CONTRAS_GHOST = "Contras Ghost",

  // Ground units
  ZONICH_TANK = "Zonich Tank",
}
